module.exports = __webpack_public_path__ + "assets/img/coin-rwa-bj.ec3d0bbb.jpg";